var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"re-loading",class:_vm.loaderClasses},[_c('div',{staticClass:"re-loading-message"},[_vm._t("default",[_vm._v(_vm._s(_vm.loadingMessage))])],2),(_vm.withLoader)?_c('div',{staticClass:"with-loader"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }